export default __webpack_public_path__ + "static/media/description.d64fbfad.svg";